<template>
	<v-dialog :model-value="!!active" max-width="480" persistent>
		<v-card v-if="active">
			<v-card-title class="text-wrap">{{ active.title }}</v-card-title>
			<v-card-text v-if="active.content">{{ active.content }}</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn variant="text" :disabled="busy" @click="settle(false)">
					{{ active.cancelText || "Cancel" }}
				</v-btn>
				<v-btn
					:color="active.okType === 'danger' ? 'error' : 'primary'"
					variant="flat"
					:loading="busy"
					@click="settle(true)"
				>
					{{ active.okText || "OK" }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { confirmState } from "@/plugins/confirm";

export default {
	name: "ConfirmHost",
	data() {
		return { busy: false };
	},
	computed: {
		active() {
			return confirmState.active;
		}
	},
	methods: {
		async settle(confirmed) {
			const active = this.active;
			const handler = confirmed ? active.onOk : active.onCancel;
			if (handler) {
				this.busy = true;
				try {
					await handler();
				} finally {
					this.busy = false;
				}
			}
			active.resolve(confirmed);
			confirmState.active = null;
		}
	}
};
</script>
